var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C3.13833 14 0 10.8617 0 7C0 3.13833 3.13833 0 7 0C10.8617 0 14 3.13833 14 7C14 10.8617 10.8617 14 7 14ZM7 0.583333C3.465 0.583333 0.583333 3.465 0.583333 7C0.583333 10.535 3.465 13.4167 7 13.4167C10.535 13.4167 13.4167 10.535 13.4167 7C13.4167 3.465 10.535 0.583333 7 0.583333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00015 14C4.74848 14 2.98682 10.92 2.98682 7C2.98682 3.08 4.74848 0 7.00015 0C9.25182 0 11.0135 3.08 11.0135 7C11.0135 10.92 9.25182 14 7.00015 14ZM7.00015 0.583333C5.11015 0.583333 3.55848 3.465 3.55848 7C3.55848 10.535 5.09848 13.4167 7.00015 13.4167C8.90182 13.4167 10.4418 10.535 10.4418 7C10.4418 3.465 8.89015 0.583333 7.00015 0.583333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5767 2.98669H1.42334V3.57003H12.5767V2.98669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5767 10.4417H1.42334V11.025H12.5767V10.4417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7082 6.70831H0.291504V7.29165H13.7082V6.70831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29183 0.291687H6.7085V13.7084H7.29183V0.291687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.509e65d0de611a748ee93ae871ce44ee.svg";
export { ForwardRef as ReactComponent };